import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { BitmapTextFieldProperties } from "@lib/titan2/dist/game/control/properties/BitmapTextFieldProperties";
import { FilterBrightness } from "@lib/titan2/dist/game/control/properties/FilterProperties";
import { MovieClipProperties } from "@lib/titan2/dist/game/control/properties/MovieClipProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import * as PIXI from "pixi.js";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
export var ReelAnim;
(function (ReelAnim) {
    ReelAnim[ReelAnim["LAND"] = 0] = "LAND";
    ReelAnim[ReelAnim["LOOP"] = 1] = "LOOP";
    ReelAnim[ReelAnim["STATIC"] = 2] = "STATIC";
    ReelAnim[ReelAnim["PANELHIT"] = 3] = "PANELHIT";
})(ReelAnim || (ReelAnim = {}));
/**
 * AbstractReelProperties.ts
 */
export class AbstractReelProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return (super.equals(other) &&
            this.size.equals(other.size) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.backgroundPurchaseProperties.equals(other.backgroundPurchaseProperties) &&
            this.spinProperties.equals(other.spinProperties) &&
            this.symbolAnimationProperties.getKeys().every((val, index) => val === other.symbolAnimationProperties.getKeys()[index]) &&
            this.symbolAnimationProperties.getValues().every((val, index) => val.equals(other.symbolAnimationProperties.getValues()[index])) &&
            this.freeSpinProperties?.equals(other?.freeSpinProperties) &&
            this.freeSpinFieldProperties?.equals(other?.freeSpinFieldProperties) &&
            this.freeSpinFieldRotation === other.freeSpinFieldRotation &&
            this.fieldPropertiesEqual(this.symbolProperties, other.symbolProperties) &&
            this.spinePosition.equals(other.spinePosition) &&
            this.disabledProperties?.equals(other.disabledProperties) &&
            this.disabledFilterProperties?.equals(other.disabledFilterProperties) &&
            this.backgroundAnimationProperties.equals(other.backgroundAnimationProperties) &&
            this.highlightAnimationProperties.equals(other.highlightAnimationProperties) &&
            this.symbolAnimationSpineProperties.equals(other.symbolAnimationSpineProperties) &&
            this.wildAnims === other.wildAnims &&
            this.superWildAnims === other.superWildAnims &&
            this.numberAnims === other.numberAnims &&
            this.freeSpinAnims === other.freeSpinAnims &&
            this.collectibleAnims === other.collectibleAnims &&
            this.scatterAnims === other.scatterAnims &&
            this.suspenseAnim === other.suspenseAnim &&
            this.collectibleProperties.equals(other.collectibleProperties) &&
            this.suspenseAnimationProperties === other.suspenseAnimationProperties);
    }
    fieldPropertiesEqual(a, b) {
        if (a instanceof BitmapTextFieldProperties) {
            if (b instanceof BitmapTextFieldProperties) {
                return a.equals(b);
            }
            return false;
        }
        else if (a instanceof TextFieldProperties) {
            if (b instanceof TextFieldProperties) {
                return a.equals(b);
            }
            return false;
        }
        return a === b;
    }
    setDefaultValues() {
        this.spinePosition = new PIXI.Point(0, 0);
        this.backgroundProperties = new SpriteProperties(SlingoStyle.REEL, SlingoStyle.MODULE);
        this.backgroundPurchaseProperties = new SpriteProperties(SlingoStyle.REEL_PURCHASE, SlingoStyle.MODULE);
        this.spinProperties = new MovieClipProperties(SlingoStyle.REEL_ANIMATION, SlingoStyle.MODULE, 18);
        this.spinProperties.loop = true;
        this.symbolProperties = new TextFieldProperties(FontStyle.REEL_SYMBOL, null, null, ControlConstants.CENTER);
        this.disabledProperties = new SpriteProperties(SlingoStyle.REEL_SYMBOL_DISABLED, SlingoStyle.MODULE);
        this.disabledFilterProperties = new FilterBrightness(0.6);
        this.symbolAnimationProperties = new Dictionary();
        this.symbolAnimationProperties.setValue(SlingoStyle.JOKER, new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION + SlingoStyle.JOKER, SlingoStyle.MODULE));
        this.symbolAnimationProperties.setValue(SlingoStyle.SUPER_JOKER, new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION + SlingoStyle.SUPER_JOKER, SlingoStyle.MODULE));
        this.symbolAnimationProperties.setValue(SlingoStyle.DEVIL, new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION + SlingoStyle.DEVIL, SlingoStyle.MODULE));
        this.symbolAnimationProperties.setValue(SlingoStyle.COIN, new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION + SlingoStyle.COIN, SlingoStyle.MODULE));
        this.freeSpinProperties = new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION + SlingoStyle.FREE_SPIN, SlingoStyle.MODULE);
        this.highlightAnimationProperties = new SpineProperties(SlingoStyle.REEL_SYMBOL_HIGHLIGHT, SlingoStyle.MODULE);
        this.freeSpinFieldProperties = new TextFieldProperties(FontStyle.FREE_SPIN_SYMBOL, null, SlingoLang.FREE_SPIN, ControlConstants.CENTER);
        this.freeSpinFieldProperties.position = new PIXI.Point(48, 0);
        this.freeSpinFieldProperties.size = new PIXI.Point(180, 120);
        this.freeSpinFieldProperties.multiline = true;
        this.freeSpinFieldRotation = -12;
        this.symbolAnimationProperties.setValue(SlingoStyle.NUMBER, new SpineProperties(SlingoStyle.REEL_NUMBER_ANIMATION, SlingoStyle.MODULE));
        this.reelSetsStandard = [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "J", "SJ", "FS", "D"],
            ["16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "J", "SJ", "FS", "D"],
            ["31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "J", "SJ", "FS", "D"],
            ["46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "J", "SJ", "FS", "D"],
            ["61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "J", "SJ", "FS", "D"],
        ];
        this.reelSetsPurchase = [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "J", "SJ", "D"],
            ["16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "J", "SJ", "D"],
            ["31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "J", "SJ", "D"],
            ["46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "J", "SJ", "D"],
            ["61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "J", "SJ", "D"],
        ];
        this.symbolAnimationSpineProperties = new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION, SlingoStyle.MODULE, new PIXI.Point(102, 82));
        this.wildAnims = ["wild_Land", "wild_win", "wild_static"];
        this.superWildAnims = ["super_wild_Land", "super_wild_win", "super_wild_static"];
        this.scatterAnims = ["scatter_land", "scatter_win", "scatter_static"];
        this.numberAnims = ["ReelNumberAnimation_land", "ReelNumberAnimation_ready", undefined];
        this.freeSpinAnims = [undefined, "free_spins_win", "free_spins_static"];
        this.collectibleAnims = ["collect_symbol_land", undefined, "collect_symbol_static", "collect_symbol_PanelHit"];
        this.suspenseAnim = "suspenseSpinEffect";
        this.suspenseAnimationProperties = new SpineProperties(SlingoStyle.REEL_SYMBOL_ANIMATION, SlingoStyle.MODULE, new PIXI.Point(102, 82));
        this.suspenseAnimationProperties.defaultAnimation = this.suspenseAnim;
        this.motionBlur = new PIXI.Point(0, 50);
    }
}
//# sourceMappingURL=AbstractReelProperties.js.map